<template>
  <div class="header">
    <div>
      <router-link to="/" class="h-title">
        <img class="fbtcb-icon" :src="TAXLITERACY" alt="line-edit"
      /></router-link>
    </div>
  </div>
</template>

<script>
import LINEEDIT from "@/assets/icons/Line Edit.svg";
import TAXLITERACY from "@/assets/icons/Tax Literacy.svg";

export default {
  name: "Header",
  props: {},
  data() {
    return {
      TAXLITERACY,
      LINEEDIT,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  background-color: #ffffff;
  height: 56px;
  display: flex;
  justify-content: center;
}
.header img {
  height: 45px;
}
.header > div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  padding: 0px 30px;
  box-sizing: border-box;
}

.h-title {
  margin: 0;
  text-decoration: unset;
  display: flex;
  align-items: center;
}

.h-title :hover {
  color: #393d43;
}

.h-humberger {
  display: flex;
  align-items: center;
}

/*size > 768px */
@media only screen and (min-width: 769px) {
  .header {
    width: 100%;
    margin: auto;
    height: 80px;
  }
  .header img {
    height: 60px;
  }
  .header > div {
    padding: 0 20px;
  }
  .h-humberger {
    visibility: hidden;
  }
}
</style>
